/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'classnames';
export var LoaderSizes;
(function (LoaderSizes) {
    LoaderSizes[LoaderSizes["xxsmall"] = 16] = "xxsmall";
    LoaderSizes[LoaderSizes["xsmall"] = 24] = "xsmall";
    LoaderSizes[LoaderSizes["small"] = 32] = "small";
    LoaderSizes[LoaderSizes["medium"] = 48] = "medium";
    LoaderSizes[LoaderSizes["large"] = 64] = "large";
    LoaderSizes[LoaderSizes["xlarge"] = 128] = "xlarge";
    LoaderSizes[LoaderSizes["xxlarge"] = 256] = "xxlarge";
})(LoaderSizes || (LoaderSizes = {}));
export var LabelPosition;
(function (LabelPosition) {
    LabelPosition["default"] = "";
    LabelPosition["left"] = "alt";
    LabelPosition["bottom"] = "vert";
})(LabelPosition || (LabelPosition = {}));
export default function Loader({ size = LoaderSizes.small, label, position = LabelPosition.default }) {
    const className = clsx('qmb-loading', {
        [`--${position}`]: position !== LabelPosition.default,
        [`--${size}`]: true
    });
    return (React.createElement("div", { className: className, "aria-hidden": "true", "data-title": label },
        React.createElement("svg", { id: "load-spinner", viewBox: "0 0 128 128", role: "img" },
            React.createElement("path", { className: "sprite", d: "M104,81.26c0,22.45-18.2,40.64-40.64,40.64c-22.67,0-41.05-17.3-41.05-39.97c0-15.22,7.58-24.26,7.58-24.26\n    c1.22-2.15,2.5-4.38,3.81-6.75c7-12.61,2.56-25.75,2.56-25.75s4.97,2.94,8.76,10.47c3.79,7.53,2.78,20.09,2.78,20.09\n    c7.91-10.53,3.53-22.6,3.1-35.16S62.88,3.15,62.88,3.15c-7.32,17.31,7.57,29.42,13.41,35.96c7.64,8.55,7.16,23.19,7.16,23.19\n    c4.27-9.08,1.07-15.65,0.53-25.59c-0.53-9.94,7.37-13.04,7.37-13.04s-1.6,7.32,0.11,16.88c1.7,9.51,15.75,20.38,15.92,39.82l0-0.21\n    l0,1.08c0,24.08-19.52,43.6-43.6,43.6c-23.84,0-43.17-19.33-43.17-43.17c0-23.6,19.13-42.74,42.74-42.74\n    c23.37,0,42.31,18.94,42.31,42.31c0,23.13-18.75,41.88-41.88,41.88c-22.9,0-41.47-18.57-41.47-41.47\n    c0-22.67,18.38-41.05,41.05-41.05C85.8,40.62,104,58.81,104,81.26" }))));
}
Loader.propTypes = {
    size: PropTypes.oneOf(Object.values(LoaderSizes))
};
Loader.defaultProps = {
    size: LoaderSizes.small
};
